import React from 'react';
import {WidgetIdType} from "../../../store/spirs/reducers/widgetIdReducer";
import {useTranslation} from "react-i18next";

// Текст, который возвращает wgt-s3-cdn.statscore.com если запрос на виджет завершился ошибкой
const WIDGET_LOADING_FAILED_TEXT = "Widget could not be loaded";

export const Widget = React.memo(({widgetId, configurationId}: WidgetIdType) =>{
    const ref = React.useRef<HTMLDivElement>(null);
    const { t } = useTranslation();
    const [hasError, setHasError] = React.useState(false);
    const [isVisible, setIsVisible] = React.useState(false);

    React.useEffect(() => {
        if (!widgetId || !configurationId || !ref.current) {
            return;
        }
        const STATSCOREWidgets = (window as any).STATSCOREWidgets;
        if (!STATSCOREWidgets || !STATSCOREWidgets.onLoad) return;
        console.log('widget for widgetId and configurationId', widgetId, configurationId)
        STATSCOREWidgets.onLoad((err: any) => {
            if (err) {
                console.error(err)
                return;
            }
            const inputData = { eventId: widgetId, language: 'ru' };
            new STATSCOREWidgets.Widget(ref.current, configurationId, inputData, {});
        });
    },[widgetId, configurationId, ref]);

    React.useEffect(() => {
        setHasError(false);
        setIsVisible(false);

        const checkLoadingFail = setTimeout(() => {
            if (ref.current?.innerText.includes(WIDGET_LOADING_FAILED_TEXT)) {
                setHasError(true);
            } else {
                setIsVisible(true);
            }
        }, 600);

        return () => clearTimeout(checkLoadingFail);
    }, [widgetId, configurationId]);

        return (
            <>
                {widgetId &&
                    <div className="widgets">
                        {hasError && <div className="inline-block ml-4">{t("widget.unavailable")}</div>}
                        <div className={`${isVisible ? '' : 'hidden'}`}  ref={ref}/>
                    </div>}
            </>
        );
}, (a, b) => a.widgetId === b.widgetId && a.configurationId === b.configurationId);
